import { render, staticRenderFns } from "./ZaloConversationItem.vue?vue&type=template&id=1f314478&scoped=true"
import script from "./ZaloConversationItem.vue?vue&type=script&lang=js"
export * from "./ZaloConversationItem.vue?vue&type=script&lang=js"
import style0 from "./ZaloConversationItem.vue?vue&type=style&index=0&id=1f314478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f314478",
  null
  
)

export default component.exports